import { Injectable } from '@angular/core';
import { CatalogoServicios } from '../model/catalogo-servicios';


import { Consorcio } from '../model/Consorcio';
import { Http, Response, Headers } from "@angular/http";
import "rxjs/add/operator/map";
import { Observable } from "rxjs/Observable";

import { UtilitiesService } from '../services/utilities.service'

import 'rxjs/add/operator/catch';
@Injectable()
export class CatalogoServiciosService {



  constructor(
    private _http: Http,
    private _utilities: UtilitiesService
  ) { }

  getServicios(query: any): Observable<CatalogoServicios[]> {

    let json = { "Metodo": "getCatalogoServicio", "Datos": query };

    let params = "Data=" + this._utilities.getEscapeString(JSON.stringify(json));

    let headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });

    return this._http.post(this._utilities.getURL("get"),
      params, { headers: headers }).map(res => res.json());

  }

  public insert(catalogo: CatalogoServicios) {

    let json = { "Metodo": "postCatalogoServicio", "Datos": catalogo };

    let params = "Data=" + this._utilities.getEscapeString(JSON.stringify(json));
    let headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });

    return this._http.post(this._utilities.getURL("post"),
      params, { headers: headers }).map(res => res.json());
  }

  public delete(cobro: CatalogoServicios) {

    let json = { "Metodo": "deleteCatalogoServicio", "Datos": cobro };

    let params = "Data=" + this._utilities.getEscapeString(JSON.stringify(json));
    let headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });

    return this._http.post(this._utilities.getURL("post"),
      params, { headers: headers }).map(res => res.json());


  }

}




// WEBPACK FOOTER //
// D:/Proyectos/tpl viejo prueba/eflowTPL/src/app/services/catalogo-servicios.service.ts